"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var EventGroups =
/*#__PURE__*/
function () {
  function EventGroups() {
    var _this = this;

    (0, _classCallCheck2.default)(this, EventGroups);
    this.eventGroups = {
      ON_LOAD: 'onLoad',
      ON_RECEIVE_ALARM: 'onReceiveAlarm',
      ON_RENDER_ALARM: 'onRenderAlarm',
      ON_RENDER_ALL: 'onRenderAll',
      ON_DISMISS_ALARM: 'onDismissAlarm',
      CREATE_ALARM: 'createAlarm'
    };
    this.keys().forEach(function (key) {
      var value = _this.eventGroups[key];
      _this[key] = value;
    });
  }

  (0, _createClass2.default)(EventGroups, [{
    key: "keys",
    value: function keys() {
      return Object.keys(this.eventGroups);
    }
  }, {
    key: "getByKey",
    value: function getByKey(key) {
      return this[key];
    }
  }]);
  return EventGroups;
}();

var _default = new EventGroups();

exports.default = _default;
module.exports = exports.default;